import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_arreglos} from '@/FirebaseConfig'
Vue.use(Vuex)
export default {
  namespaced:true,
  state: {
    registro:{}
  },
  actions: {
    obtener_todo: async ({state}) => coleccion_arreglos.doc('lista').onSnapshot(doc=>  state.registro = doc.exists ? doc.data() : {} ),

    actualizar_codigo: ({state}, {arreglo, elemento}) => {
      const {registro} = state
      if ( typeof elemento == 'string') 
      if (!elemento) return
      if (elemento.descripcion == '' || !elemento.descripcion) return
      if (!registro[arreglo]) registro[arreglo] = []
      
      registro[arreglo].filter(item =>{
        return item.descripcion == elemento.descripcion})

      if (registro[arreglo].filter(item => item.descripcion == elemento.descripcion).length > 0 ) {
        registro[arreglo].map(item => {
          if ( item.descripcion == elemento.descripcion ) item = elemento 
        })
      } else {
        registro[arreglo].push({elemento: elemento})
      }
      coleccion_arreglos.doc('lista').set({...registro} )
    },

    crear: ({state}, {arreglo, descripcion}) => {
      const {registro} = state
      if (descripcion == '' || !descripcion) return
      if (!registro[arreglo]) registro[arreglo] = []
      
      if( registro[arreglo].filter(item => item.descripcion == descripcion ).length>0 ) return 

      registro[arreglo].push({descripcion})
    
      coleccion_arreglos.doc('lista').set({...registro} )
    },

    eliminar:({state}, {arreglo, elemento})=> coleccion_arreglos.doc('lista').update({ [arreglo] : state.registro[arreglo].filter( item => item.descripcion != elemento.descripcion ) }),
    
  },
  getters: {
    registro: state => arreglo => {
      return state.registro[arreglo] && state.registro[arreglo].length>0 ?  state.registro[arreglo].sort() : []
    }
  }
}
  